<template>
  <modal
    name="menuFilter"
    modal-style="compact"
  >
    <div class="section section--half-padding">
      <div class="layout layout--horizontal">
        <h2 class="title title--2">Filters</h2>
        <button
          type="button"
          class="link link--margin primary"
          @click="clearFilters"
        >
          Clear Filters
        </button>
      </div>

      <div
        v-for="group in filterAttributes.groups"
        :key="group.type"
      >
        <div class="title title--section layout layout--horizontal no-spacing no-spacing-top">
          <h3>{{ group.title }}</h3>
          <p
            v-if="group.description"
            class="smaller auto-spacing-left regular"
          >
            {{ group.description }}
          </p>
        </div>

        <div class="checkbox-group no-spacing">
          <div class="checkbox-group__items">
            <div
              v-for="attribute in group.attributes"
              :key="attribute.id"
              class="checkbox-group__item"
            >
              <input
                :id="attribute.id"
                class="checkbox-group__input"
                type="checkbox"
                :name="attribute.id"
                :checked="selectedFilterIds.includes(attribute.id)"
                @input="filterCheckboxInputHandler(attribute, $event)"
              >

              <label
                class="checkbox-group__label"
                :for="attribute.id"
              >
                <img
                  v-if="attribute.imageUrl"
                  class="image-icon image-icon--24"
                  :src="attribute.imageUrl"
                  :alt="attribute.name"
                >
                <span class="checkbox-group__label-title">{{ attribute.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section--half-padding section--alt-background section--shadow sticky-bottom">
      <div class="layout layout--horizontal layout--horizontal-equal">
        <button
          class="button button--primary"
          type="button"
          @click="applyFilters"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </modal>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MenuFilterModal',

    data() {
      return {
        selectedFilterIds: []
      };
    },

    computed: {
      ...mapGetters('menu', ['filterAttributes'])
    },

    watch: {
      filterAttributes: 'onWatchFilterAttributes'
    },

    methods: {
      applyFilters() {
        this.$store.dispatch('menu/updateSelectedFilters', this.selectedFilterIds);
        this.$closeModal('menuFilter');
      },

      clearFilters() {
        this.$store.dispatch('menu/updateSelectedFilters', []);
        this.$closeModal('menuFilter');
      },

      onWatchFilterAttributes() {
        this.selectedFilterIds = [];

        this.filterAttributes.selected.forEach((attribute) => {
          this.selectedFilterIds.push(attribute.id);
        });
      },

      filterCheckboxInputHandler(attribute, event) {
        const isSelected = event.target.checked;

        if (isSelected) {
          this.selectedFilterIds.push(attribute.id);
        }

        else {
          this.selectedFilterIds = this.selectedFilterIds.filter(id => id !== attribute.id);
        }
      }
    }
  };
</script>
